"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHECKBOX_SIZES = exports.CHECKBOX_SIZE_BIG = exports.CHECKBOX_SIZE_DEFAULT = void 0;
var CHECKBOX_SIZE_DEFAULT = 'default';
exports.CHECKBOX_SIZE_DEFAULT = CHECKBOX_SIZE_DEFAULT;
var CHECKBOX_SIZE_BIG = 'big';
exports.CHECKBOX_SIZE_BIG = CHECKBOX_SIZE_BIG;
var CHECKBOX_SIZES = [CHECKBOX_SIZE_DEFAULT, CHECKBOX_SIZE_BIG];
exports.CHECKBOX_SIZES = CHECKBOX_SIZES;